import { getValueAndUnit } from 'polished';
import { remToPx } from '../remToPx';
export const calculateLineHeight = (fontSize) => {
    if (!fontSize) {
        return undefined;
    }
    const [amount, unit] = getValueAndUnit(fontSize);
    const baseLineHeight = 24;
    if (unit && unit !== 'px' && unit !== 'rem') {
        return undefined;
    }
    const value = unit === 'rem' ? remToPx(amount) : amount;
    return Math.ceil(value / baseLineHeight) * (baseLineHeight / value);
};
